// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GlobalCalendar_monthGrid__mP-im {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 4px;
}

.GlobalCalendar_monthWeekday__tXdLs {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #acacac;
  text-align: center;
  padding: 4px 0;
}

.GlobalCalendar_monthEmptyCell__xplwt {
  aspect-ratio: 1/1;
}

.GlobalCalendar_monthDay__W0muH {
  aspect-ratio: 1/1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  background: #f4f5f7;
  border: 1px solid transparent;
  border-radius: 3px;
  cursor: pointer;
  padding: 2px;
  font-size: 11px;
  line-height: 1;
  color: #838383;
  transition: transform 0.1s ease;
}
.GlobalCalendar_monthDay__W0muH:hover:not(:disabled) {
  transform: scale(1.05);
  border-color: var(--primary-color);
}
.GlobalCalendar_monthDay__W0muH:disabled {
  cursor: default;
  opacity: 0.6;
}

.GlobalCalendar_dayNum__uQej1 {
  font-weight: 600;
  font-size: 12px;
}

.GlobalCalendar_ratio__XeURl {
  font-size: 10px;
  font-family: monospace;
}

.GlobalCalendar_selected__C37XD {
  outline: 2px solid var(--primary-color);
  outline-offset: -1px;
}

.GlobalCalendar_yearGrid__O63EA {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: 10px;
}

.GlobalCalendar_yearMonth__WCFuZ {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.GlobalCalendar_yearMonthLabel__AFJ0W {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #acacac;
}

.GlobalCalendar_yearDayGrid__GoHjz {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}

.GlobalCalendar_yearEmptyCell__Pi6TE {
  width: 10px;
  height: 10px;
}

.GlobalCalendar_yearDay__H-6qC {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  border: none;
  padding: 0;
  cursor: pointer;
  background: #f4f5f7;
}
.GlobalCalendar_yearDay__H-6qC:hover:not(:disabled) {
  outline: 2px solid var(--primary-color);
}
.GlobalCalendar_yearDay__H-6qC:disabled {
  cursor: default;
}
.GlobalCalendar_yearDay__H-6qC:hover::after {
  content: attr(data-tip);
  position: absolute;
  bottom: calc(100% + 4px);
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
  padding: 1px 6px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
  pointer-events: none;
  z-index: 10;
}

.GlobalCalendar_lvl_empty__GS5Jc {
  background: #f4f5f7;
}

.GlobalCalendar_lvl_1__hg8b4 {
  background: #f7c7c5;
}

.GlobalCalendar_lvl_2__dl5Oh {
  background: #f1d8a3;
}

.GlobalCalendar_lvl_3__zca9G {
  background: #e9e7a5;
}

.GlobalCalendar_lvl_4__MwaEc {
  background: #b3d8b5;
}

.GlobalCalendar_lvl_5__MnEr6 {
  background: #57bc8f;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/SyncMonitor/GlobalCalendar/GlobalCalendar.module.scss","webpack://./src/_common/scss/_colors.scss","webpack://./src/_common/scss/_variables.scss"],"names":[],"mappings":"AAKA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;AAJF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cCRS;EDST,kBAAA;EACA,cAAA;AAJF;;AAOA;EACE,iBAAA;AAJF;;AAOA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBC1BS;ED2BT,6BAAA;EACA,kBEhCc;EFiCd,eAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,cC9BS;ED+BT,+BAAA;AAJF;AAME;EACE,sBAAA;EACA,kCC5CM;ADwCV;AAOE;EACE,eAAA;EACA,YAAA;AALJ;;AASA;EACE,gBAAA;EACA,eAAA;AANF;;AASA;EACE,eAAA;EACA,sBAAA;AANF;;AASA;EACE,uCAAA;EACA,oBAAA;AANF;;AAWA;EACE,aAAA;EACA,2DAAA;EACA,SE/DS;AFuDX;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AARF;;AAWA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cC/ES;ADuEX;;AAWA;EACE,aAAA;EACA,qCAAA;EACA,QAAA;AARF;;AAWA;EACE,WAAA;EACA,YAAA;AARF;;AAWA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,mBCvGS;AD+FX;AAUE;EACE,uCAAA;AARJ;AAWE;EACE,eAAA;AATJ;AAYE;EACE,uBAAA;EACA,kBAAA;EACA,wBAAA;EACA,SAAA;EACA,2BAAA;EACA,+BAAA;EACA,WChHI;EDiHJ,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,WAAA;AAVJ;;AAgBA;EAAa,mBCtIF;AD0HX;;AAaA;EAAS,mBAAA;AATT;;AAUA;EAAS,mBAAA;AANT;;AAOA;EAAS,mBAAA;AAHT;;AAIA;EAAS,mBAAA;AAAT;;AACA;EAAS,mBAAA;EAAqB,WCnItB;ADuIR","sourcesContent":["@import '@common/scss/_variables';\n@import '@common/scss/_colors';\n\n// ─── Monthly view ────────────────────────────────────────────────────────────\n\n.monthGrid {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n  gap: 4px;\n}\n\n.monthWeekday {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $grey-300;\n  text-align: center;\n  padding: 4px 0;\n}\n\n.monthEmptyCell {\n  aspect-ratio: 1 / 1;\n}\n\n.monthDay {\n  aspect-ratio: 1 / 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  background: $grey-100;\n  border: 1px solid transparent;\n  border-radius: $border-radius;\n  cursor: pointer;\n  padding: 2px;\n  font-size: 11px;\n  line-height: 1;\n  color: $grey-400;\n  transition: transform 0.1s ease;\n\n  &:hover:not(:disabled) {\n    transform: scale(1.05);\n    border-color: $primary;\n  }\n\n  &:disabled {\n    cursor: default;\n    opacity: 0.6;\n  }\n}\n\n.dayNum {\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.ratio {\n  font-size: 10px;\n  font-family: monospace;\n}\n\n.selected {\n  outline: 2px solid $primary;\n  outline-offset: -1px;\n}\n\n// ─── Yearly view ─────────────────────────────────────────────────────────────\n\n.yearGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));\n  gap: $margin-m;\n}\n\n.yearMonth {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.yearMonthLabel {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $grey-300;\n}\n\n.yearDayGrid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n}\n\n.yearEmptyCell {\n  width: 10px;\n  height: 10px;\n}\n\n.yearDay {\n  position: relative;\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  background: $grey-100;\n\n  &:hover:not(:disabled) {\n    outline: 2px solid $primary;\n  }\n\n  &:disabled {\n    cursor: default;\n  }\n\n  &:hover::after {\n    content: attr(data-tip);\n    position: absolute;\n    bottom: calc(100% + 4px);\n    left: 50%;\n    transform: translateX(-50%);\n    background: rgba(0, 0, 0, 0.85);\n    color: $white;\n    padding: 1px 6px;\n    border-radius: 3px;\n    font-size: 10px;\n    font-weight: 600;\n    line-height: 1.3;\n    white-space: nowrap;\n    pointer-events: none;\n    z-index: 10;\n  }\n}\n\n// ─── Heat-map levels (5 = best, 1 = worst, empty = no data) ──────────────────\n\n.lvl_empty { background: $grey-100; }\n.lvl_1 { background: #f7c7c5; }\n.lvl_2 { background: #f1d8a3; }\n.lvl_3 { background: #e9e7a5; }\n.lvl_4 { background: #b3d8b5; }\n.lvl_5 { background: #57bc8f; color: $white; }\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"monthGrid": `GlobalCalendar_monthGrid__mP-im`,
	"monthWeekday": `GlobalCalendar_monthWeekday__tXdLs`,
	"monthEmptyCell": `GlobalCalendar_monthEmptyCell__xplwt`,
	"monthDay": `GlobalCalendar_monthDay__W0muH`,
	"dayNum": `GlobalCalendar_dayNum__uQej1`,
	"ratio": `GlobalCalendar_ratio__XeURl`,
	"selected": `GlobalCalendar_selected__C37XD`,
	"yearGrid": `GlobalCalendar_yearGrid__O63EA`,
	"yearMonth": `GlobalCalendar_yearMonth__WCFuZ`,
	"yearMonthLabel": `GlobalCalendar_yearMonthLabel__AFJ0W`,
	"yearDayGrid": `GlobalCalendar_yearDayGrid__GoHjz`,
	"yearEmptyCell": `GlobalCalendar_yearEmptyCell__Pi6TE`,
	"yearDay": `GlobalCalendar_yearDay__H-6qC`,
	"lvl_empty": `GlobalCalendar_lvl_empty__GS5Jc`,
	"lvl_1": `GlobalCalendar_lvl_1__hg8b4`,
	"lvl_2": `GlobalCalendar_lvl_2__dl5Oh`,
	"lvl_3": `GlobalCalendar_lvl_3__zca9G`,
	"lvl_4": `GlobalCalendar_lvl_4__MwaEc`,
	"lvl_5": `GlobalCalendar_lvl_5__MnEr6`
};
export default ___CSS_LOADER_EXPORT___;
